"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sizer = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const state_1 = require("../state");
const SizerDivider_1 = require("./SizerDivider");
const css_1 = require("./css");
const DEFAULT_MIN_WIDTH = 200;
/**
 * Centered, resizable container with two floating dividers on its left and
 * right edges. Both paddings stay equal at all times - dragging either divider
 * grows or shrinks the content symmetrically.
 *
 * The dividers are positioned absolutely on the edges of the content box so
 * they don't consume horizontal space - the content can stretch all the way
 * to the container's boundaries.
 *
 * @example
 * ```tsx
 * const sizer = new SizerState(800);
 * <Sizer state={sizer}>
 *   <Editor />
 * </Sizer>
 * ```
 */
const Sizer = ({ state: stateProp, onState, minWidth = DEFAULT_MIN_WIDTH, resizable = true, handleMargin, handleWidth, handlePadding, handleMaxHeight, className, style, children, }) => {
    const fallbackRef = React.useRef(null);
    let state;
    if (stateProp) {
        state = stateProp;
    }
    else {
        if (!fallbackRef.current)
            fallbackRef.current = new state_1.SizerState();
        state = fallbackRef.current;
    }
    React.useEffect(() => {
        onState?.(state);
    }, [state, onState]);
    const containerWidth = state.width.use();
    const desired = state.content.use();
    const contentWidth = containerWidth === 0 ? desired : Math.max(minWidth, Math.min(desired, containerWidth));
    const cls = className ? `${css_1.outerClass} ${className}` : css_1.outerClass;
    return (React.createElement("div", { ref: state.box.setEl, className: cls, style: style },
        React.createElement("div", { className: css_1.contentClass, style: { width: contentWidth } },
            children,
            resizable && containerWidth > 0 && (React.createElement(React.Fragment, null,
                React.createElement(SizerDivider_1.SizerDivider, { state: state, side: "left", minWidth: minWidth, handleMargin: handleMargin, handleWidth: handleWidth, handlePadding: handlePadding, handleMaxHeight: handleMaxHeight }),
                React.createElement(SizerDivider_1.SizerDivider, { state: state, side: "right", minWidth: minWidth, handleMargin: handleMargin, handleWidth: handleWidth, handlePadding: handlePadding, handleMaxHeight: handleMaxHeight }))))));
};
exports.Sizer = Sizer;
